export const createStyles = busy => ({
  panel: { background: '#fff', borderRadius: 12, padding: 24, boxShadow: '0 2px 12px rgba(0,0,0,.08)', marginBottom: 20 },
  row: { display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap' },
  input: { padding: '9px 11px', border: '1px solid #cbd5e1', borderRadius: 7, maxWidth: 150 },
  button: { padding: '11px 18px', border: 0, borderRadius: 7, background: '#2563eb', color: '#fff', cursor: busy ? 'wait' : 'pointer', fontSize: 14, fontWeight: 600, lineHeight: 'normal' },
  metrics: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: 12, margin: '18px 0' },
  metric: { background: '#f1f5f9', borderRadius: 9, padding: 14 },
  table: { width: '100%', borderCollapse: 'collapse', marginTop: 16 },
  cell: { padding: '10px 8px', borderBottom: '1px solid #e2e8f0', textAlign: 'right' },
});

export const IDLE_STYLES = createStyles(false);
